import React from 'react'
import { RatingContext } from '../../utils/RatingContext'
import { TEXT } from '../../i18n/text'
import { PButton } from '@porsche-design-system/components-react'
import styles from '../../assets/styles/styles.module.css'

export const ButtonBar = (): React.ReactElement => {
  const completion = React.useContext(RatingContext).formCompleted
  const loading = React.useContext(RatingContext).loading
  const language = React.useContext(RatingContext).language
  return (
    <React.Fragment>
      {!completion && (
        <PButton type='submit' variant='primary' className={styles.sendButton} loading={loading}>
          {TEXT[language].sendButton}
        </PButton>
      )}
    </React.Fragment>
  )
}
